import { h, markRaw } from "vue";
import { MutationTree } from "vuex";
import { DeviceState } from "./state";
import DeviceSetting from "@/components/common/device-setting/device-setting.vue";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<DeviceState> = {
  [defineVuexName(MODULES.DEVICE.COMMITS.TOGGLE_DEVICE_SETTING_MODAL)](
    state: DeviceState,
    payload: {
      isOpen: boolean;
      props?: any;
    },
  ) {
    const { isOpen, props } = payload;
    if (isOpen) {
      state.isSettingDeviceModalOpen = true;
      state.settingDeviceModalView = markRaw(h(DeviceSetting, props));
      return;
    }
    state.isSettingDeviceModalOpen = false;
    state.settingDeviceModalView = {};
  },
};

export default mutations;
